import { createStore } from "@xstate/store";

export const appointmentDetailStore = createStore({
  context: {
    visitId: null as string | null,
    scheduleId: null as string | null,
  },
  on: {
    "appointment.select": (_ctx, e: { visitId: string; scheduleId?: string | null }) => ({
      visitId: e.visitId,
      scheduleId: e.scheduleId ?? null,
    }),
    "appointment.clear": () => ({
      visitId: null as string | null,
      scheduleId: null as string | null,
    }),
  },
});
